import React from "react";
import BreadcrumbsHeader from "../components/breadcrumbs/BreadcrumbsHeader";

const RefundPolicy = () => {
  return (
    <div className="page-container" id="missionidd">
      {/* Breadcrumbs Header */}
    <BreadcrumbsHeader 
        title="Refund Policy" 
        backgroundImage="/images/header/about-isols.jpg" 
      />

      {/* Refund Policy Section */}
      <section className="section-about">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-12 wow slideInLeft">
              <div className="b-services-item">
                <div className="services-text">
                  <h2 className="termm">Our Refund Policy Explained</h2>
                  <p>
                    Thanks for purchasing our products/services (or subscribing to our services) at www.isolsgroup.com operated by ISOLS Group Pvt. Ltd.
                  </p>
                </div>

                <div className="services-text">
                  <p>
                    We offer a money-back guarantee for all purchases made via our website. If you are not satisfied with the product that you have purchased from us, you can get your money. You are eligible for a full reimbursement within 7 calendar days of your purchase. In case, you have purchased the service then you are eligible for a 70% reimbursement within 7 calendar days of your purchase.
                  </p>
                  <p>
                    After the 7-day period you will no longer be eligible and won't be able to receive a refund. We encourage our customers to try the product (or service) in the initial first week after their purchase to ensure it fits your needs. If you have any additional questions or would like to request a refund, feel free to contact us.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RefundPolicy;
